import { hardenCookies } from '@wix/client-security'
import { buildExpiredSessionCookie, readCookie } from './helpers'

const CLIENT_COOKIE_NAME = 'client-session-bind'
const CLIENT_HEADER = 'client-binding'

const deniedCookieNames = [
	CLIENT_COOKIE_NAME,
	CLIENT_HEADER, // adding this for precaution when hardening cookies
	'svSession',
	'smSession',
	'server-session-bind',
	'wixSession2',
	'wixSession3',
].map((cookieName) => cookieName.toLowerCase())

export const { cookie } = hardenCookies(deniedCookieNames)

export const removeSessionCookie = () => {
	const cookieParamsNoDomain = buildExpiredSessionCookie(CLIENT_COOKIE_NAME)
	const cookieParams = buildExpiredSessionCookie(CLIENT_COOKIE_NAME, location.hostname)
	// This removes cookies set after we made the switch to the new model of writing cookies without domain (for Fastly)
	cookie!.set!.call(document, cookieParamsNoDomain)
	// This removes cookies set with domain
	cookie!.set!.call(document, cookieParams)
}

export const getAndDeleteClientSessionValue = () => {
	const clientSessionValue = readCookie(CLIENT_COOKIE_NAME, cookie)
	removeSessionCookie()

	return clientSessionValue
}
